import React from 'react'
import { reviews } from '../Data/E_Offer'
import { Avatar } from 'antd'
import { Rating } from './Rating'

const Comments = () => {
  return (
   <div className='flex flex-col  items-center sm:items-start  justify-start pt-[2rem] pb-[4rem] gap-[1rem] '>
     {reviews.map((data,index)=>(
         <div key={index}  className='w-[100%] sm:w-[500px]  h-[380px] sm:h-[300px] shadow-md py-[2rem] px-[1rem]'>
               <div className='flex items-center gap-[1rem]'>
                  <Avatar src={data.avatar} size={74}/>
                  <div className='flex flex-col items-start justify-start'>
                      <h2 className='font-cinzel text-[20px]'>
                         {data.name}
                      </h2>
                      <p className='font-outfit text-[14px] text-gray-400'>{data.date}</p>
                  </div>
               </div>
               <Rating rating={data.rating}/>
               <p className='text-start font-outfit text-[20px] text-gray-800'>
                {data.comment}
               </p>
         </div>
     ))}
   </div>
  )
}

export default Comments
